import { mapNullable } from '@/utils/mapNullable';
import { AuctionCharityDto, AuctionCharityItemDto } from './schedule/auctionCharity.dto';

export function isAuctionCharityEditable(auctionCharity: AuctionCharityDto) {
  return auctionCharity.status === 'created';
}

export function isAuctionCharityItemContributableToCount(
  auctionCharityItem: AuctionCharityItemDto,
) {
  return auctionCharityItem.status === 'created' || auctionCharityItem.status === 'confirmed';
}

export function calcAuctionCharityItemStartingPrice(auctionCharityItem: AuctionCharityItemDto) {
  return (
    auctionCharityItem.showcaseItem.auctionInfo?.startingPrice ??
    mapNullable((price) => Math.ceil(price * 1.2), auctionCharityItem.showcaseItem.price)
  );
}

export function isAuctionCharityItemShouldBeHidden({
  auctionCharity,
  auctionCharityItem,
}: {
  auctionCharity: AuctionCharityDto;
  auctionCharityItem: AuctionCharityItemDto;
}) {
  return (
    auctionCharity.status === 'items-scheduled' &&
    (auctionCharityItem.status === 'denied' || auctionCharityItem.status === 'failed')
  );
}

export function getDisplayPriceAuctionCharityItem(auctionCharityItem: AuctionCharityItemDto) {
  const showcaseItem = auctionCharityItem.showcaseItem;
  return showcaseItem.auctionInfo?.currentPrice
    ? showcaseItem.auctionInfo.currentPrice
    : calcAuctionCharityItemStartingPrice(auctionCharityItem);
}
